<template>
    <div>
        <buttonlist @help="help" @opentable="opentable" @add="add" @search="search" @reflash="reflash" @exps="exps" @save="save" @del="del"
                    ref="SetBtn"></buttonlist>
        <ul class="Boxs" ref="Box" :style="{ height: tableHeight + 'px' }">
            <li class="left" ref="left">
                <wTable
                        id="xpane-0"
                        :data="dataSet"
                        :loading="loading"
                        queryData="CountCardViewInfo"
                        :filter_thousandth="['count_qty']"
                        :header="tableHeader"
                        :option="tableOption"
                        @edits="editInfo"
                        @rowdblclick="openEdit"
                        ref="singleTable"
                        :checkflg="false"
                ></wTable>
                <!--<el-table
                        :data="dataSet"
                        ref="singleTable"
                        v-loading="loading"
                        :highlight-current-row="true"
                        show-overflow-tooltip="true"
                        border
                        size="mini"
                        :height="tableHeight"
                        @row-click="editInfo"
                        header-row-class-name="headerclass"
                        style="width: 100%; margin-top:0px"
                >
                    <el-table-column type="selection" v-if="false"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="verify_desc" :label="$t('getapi[2723]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="count_plan_sign" :label="$t('getapi[7436]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="count_card_flag_name" :label="$t('getapi[7437]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="card_flag_name" :label="$t('getapi[7438]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="count_date" :label="$t('getapi[7439]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="count_person" :label="$t('getapi[7440]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="create_person" :label="$t('getapi[7441]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="dept" :label="$t('getapi[7442]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="count_card_issue_no" :label="$t('getapi[7430]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="count_card_no" :label="$t('getapi[7431]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="count_area" :label="$t('getapi[7432]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="so_code" :label="$t('getapi[4285]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="part_code" :label="$t('getapi[112]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="part_version" :label="$t('getapi[149]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="routing_no" :label="$t('getapi[573]')" align="right"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="count_qty" :label="$t('getapi[7443]')" align="right"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="count_measure" :label="$t('getapi[3100]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="sys_measure" :label="$t('getapi[7444]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="part_category" :label="$t('getapi[4241]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="remark" :label="$t('getapi[143]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="create_time" :label="$t('getapi[7445]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="item_code" :label="$t('getapi[3437]')"></el-table-column>
                </el-table>-->
            </li>
            <li class="resize" ref="resize">
                <i class="el-icon-caret-right" @click="leftt(0)"></i>
                <i class="el-icon-caret-left" @click="leftt(1)"></i>
            </li>
            <li class="mid" ref="mid">
                <div  style="float:right;position: relative;">
                    <el-button type="danger" size="mini" icon="el-icon-close" @click="colseEdit"></el-button>
                </div>
                <div>
                    <div>
                        <el-button type="primary" size="mini" @click="changeCardNo">{{$t('getapi[7446]')}}</el-button>
                        <el-button type="primary" size="mini" @click="batchSaveCountCard">{{$t('getapi[7447]')}}</el-button>
                        <el-button type="primary" size="mini" @click="verify">{{$t('getapi[439]')}}</el-button>
                    </div>
                    <table>
                        <tr>
                            <td  colspan="6">
                                <el-divider content-position="left">{{$t('getapi[7448]')}}</el-divider>
                            </td>
                        </tr>
                        <tr>
                            <td style="width:60px;min-width:60px">{{$t('getapi[7436]')}}</td>
                            <td style="width:150px;min-width:150px">
                                <el-input v-model="dataDetail.Head.count_plan_sign" type="text" size="mini" :disabled="true"></el-input>
                            </td>
                            <td style="width:60px;min-width:60px">{{ $t('getapi[4042]') }}</td>
                            <td style="width:180px;min-width:180px">
                                <el-date-picker v-model="dataDetail.Head.count_date" type="date" size="mini"
                                                style="width:100%" :disabled="dataDetail.Head.card_flag != 0 && dataDetail.Head.card_flag != 1 && dataDetail.Head.card_flag != 2"></el-date-picker>
                            </td>
                            <td style="width:60px;min-width:60px">{{ $t('getapi[7449]') }}</td>
                            <td style="width:180px;min-width:180px">
                                <el-select v-model="dataDetail.Head.card_flag">
                                    <el-option :label="$t('getapi[2406]')" :value=0></el-option>
                                    <el-option :label="$t('getapi[7450]')" :value=1></el-option>
                                    <el-option :label="$t('getapi[1902]')" :value=2></el-option>
                                </el-select>
                            </td>
                        </tr>
                        <tr>
                            <td></td>
                            <td>
                                <el-checkbox v-model="continuousentry" true-label='1' false-label='0'>{{$t('getapi[7451]')}}</el-checkbox>
                            </td>
                            <td>{{$t('getapi[7440]')}}</td>
                            <td>
                                <el-input v-model="dataDetail.Head.count_person" type="text" size="mini" :disabled="dataDetail.Head.card_flag != 0 && dataDetail.Head.card_flag != 1 && dataDetail.Head.card_flag != 2"></el-input>
                            </td>
                            <td>{{$t('getapi[7441]')}}</td>
                            <td>
                                <el-input v-model="dataDetail.Head.create_person" type="text" size="mini" :disabled="true"></el-input>
                            </td>
                        </tr>
                        <tr>
                            <td colspan="6">
                                <el-divider content-position="left">{{$t('getapi[7452]')}}</el-divider>
                            </td>
                        </tr>
                        <tr>
                            <td>{{$t('getapi[7453]')}}</td>
                            <td>
                                <el-input v-model="dataDetail.Head.count_card_issue_no" type="text" size="mini" :disabled="dataDetail.Head.card_flag != 0 && dataDetail.Head.card_flag != 1 && dataDetail.Head.card_flag != 2"></el-input>
                            </td>
                            <td>{{$t('getapi[7431]')}}</td>
                            <td>
                                <el-input v-model="dataDetail.Head.count_card_no" type="text" size="mini" :disabled="dataDetail.Head.card_flag != 0 && dataDetail.Head.card_flag != 1 && dataDetail.Head.card_flag != 2"></el-input>
                            </td>
                            <td>{{$t('getapi[7432]')}}</td>
                            <td>
                                <el-select v-model="dataDetail.Head.count_area" size="mini" :disabled="dataDetail.Head.card_flag != 0 && dataDetail.Head.card_flag != 1 && dataDetail.Head.card_flag != 2">
                                    <el-option v-for="item in countareaArr" :key="item.Code" :label="item.Name"
                                               :value="item.Code"></el-option>
                                </el-select>
                            </td>
                        </tr>
                        <tr>
                            <td>{{$t('getapi[7433]')}}</td>
                            <td>
                                <el-input v-model="dataDetail.Head.so_code" type="text" size="mini" @change="getPartInfo" :disabled="dataDetail.Head.card_flag != 0"></el-input>
                            </td>
                            <td>{{$t('getapi[573]')}}</td>
                            <td>
                                <el-select v-model="dataDetail.Head.routing_no" size="mini" :disabled="dataDetail.Head.card_flag != 0 && dataDetail.Head.card_flag != 1 && dataDetail.Head.card_flag != 2">
                                    <el-option v-for="item in routingnoArr" :key="item.value" :label="item.label"
                                               :value="item.value"></el-option>
                                </el-select>
                            </td>
                            <td>{{ $t('getapi[112]') }}</td>
                            <td>
                                <el-input v-model="dataDetail.Head.part_code" type="text" size="mini" :disabled="dataDetail.Head.card_flag != 0"></el-input>
                            </td>
                        </tr>
                        <tr>
                            <td>{{ $t('getapi[888]') }}</td>
                            <td>
                                <el-select v-model="dataDetail.Head.count_measure" size="mini" :disabled="dataDetail.Head.card_flag != 0">
                                    <el-option v-for="item in countmeasureArr" :key="item.value" :label="item.label"
                                               :value="item.value"></el-option>
                                </el-select>
                            </td>
                            <td>{{ $t('getapi[7443]') }}</td>
                            <td>
                                <el-input v-model="dataDetail.Head.count_qty" type="number" autocomplete="off" title="" @mousewheel.native.prevent size="mini" :disabled="dataDetail.Head.card_flag != 0"></el-input>
                            </td>
                            <td>{{ $t('getapi[149]') }}</td>
                            <td>
                                <el-input v-model="dataDetail.Head.part_version" type="text" size="mini" :disabled="dataDetail.Head.card_flag != 0"></el-input>
                            </td>
                        </tr>
                        <tr>
                            <td>{{ $t('getapi[7444]') }}</td>
                            <td>
                                <el-input v-model="dataDetail.Head.sys_measure" type="text" size="mini" :disabled="true"></el-input>
                            </td>
                            <td>{{ $t('getapi[4241]') }}</td>
                            <td>
                                <el-input v-model="dataDetail.Head.part_category" type="text" size="mini" :disabled="true"></el-input>
                            </td>
                            <td>{{ $t('getapi[876]') }}</td>
                            <td>
                                <el-input v-model="dataDetail.Head.item_code" type="text" size="mini" :disabled="true"></el-input>
                            </td>
                        </tr>
                        <tr>
                            <td>{{ $t('getapi[143]') }}</td>
                            <td colspan="5">
                                <el-input v-model="dataDetail.Head.remark" type="textarea" size="mini"></el-input>
                            </td>
                        </tr>
                        <tr>
                            <td>{{ $t('getapi[2723]') }}</td>
                            <td colspan="5">
                                <el-input v-model="dataDetail.Head.verify_desc" type="textarea" size="mini" :disabled="true"></el-input>
                            </td>
                        </tr>
                    </table>
                </div>
            </li>
        </ul>
        <el-row class="page">
            <el-col :span="18">
                <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :page-sizes="[100, 200, 300, 400]"
                        :page-size="pageSize"
                        :pager-count="5"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="total"
                ></el-pagination>
            </el-col>
            <el-col :span="6">
                <div style="text-align: right;line-height: 30px;color: #545c64;font-size: 95%;">{{$t('getapi[7980]')}}:{{ DbTbNames
                    }}
                </div>
            </el-col>
        </el-row>
        <serce :isVisible="isVisible" queryData="CountCardViewInfo" ref="ser" @getser="serclick"></serce>
        <ctable :isVisible="false" :title="$t('getapi[6689]')" queryData="CountCardViewInfo" tabNo="0" ref="ctab"
                @getctab="sortclick"></ctable>

        <el-dialog v-dialogDrag :visible.sync="isShowChangeCardNo" :title="$t('getapi[8852]')" width="15%">
            <div>
                <table>
                    <tr>
                        <td>{{$t('getapi[8853]')}}</td>
                        <td><el-input v-model="dataDetail.Head.count_card_no" type="text" size="mini" style="width:120px"></el-input></td>
                    </tr>
                    <tr>
                        <td>{{$t('getapi[8854]')}}</td>
                        <td>
                            <el-input v-model="new_count_card_no" type="text" size="mini" style="width:120px"></el-input>
                        </td>
                    </tr>
                </table>
            </div>
            <span slot="footer" class="dialog-footer">
				<el-button size="mini" @click="isShowChangeCardNo = false">{{$t('getapi[2054]')}}</el-button>
				<el-button size="mini" type="primary" @click="confirmChangeCardNo">{{$t('getapi[1146]')}}</el-button>
			</span>
        </el-dialog>

        <el-dialog v-dialogDrag :visible.sync="isShowBatchSaveCountCard" :title="$t('getapi[8855]')" width="15%">
            <div>
                <table>
                    <tr>
                        <td>{{$t('getapi[7453]')}}</td>
                        <td><el-input v-model="dataDetail.Head.count_card_issue_no" type="text" size="mini" style="width:120px"></el-input></td>
                    </tr>
                    <tr>
                        <td>{{$t('getapi[8856]')}}</td>
                        <td>
                            <el-input v-model="startcardno" type="text" size="mini" style="width:120px"></el-input>
                        </td>
                    </tr>
                    <tr>
                        <td>{{$t('getapi[8857]')}}</td>
                        <td>
                            <el-input v-model="endcardno" type="text" size="mini" style="width:120px"></el-input>
                        </td>
                    </tr>
                    <tr>
                        <td>{{$t('getapi[7432]')}}</td>
                        <td>
                            <el-select v-model="dataDetail.Head.count_area" size="mini" style="width:120px">
                                <el-option v-for="item in countareaArr" :key="item.Code" :label="item.Name"
                                           :value="item.Code"></el-option>
                            </el-select>
                        </td>
                    </tr>
                    <tr>
                        <td>{{$t('getapi[7439]')}}</td>
                        <td>
                            <el-date-picker v-model="dataDetail.Head.count_date" type="date" size="mini"
                                            style="width:120px"></el-date-picker>
                        </td>
                    </tr>
                </table>
            </div>
            <span slot="footer" class="dialog-footer">
				<el-button size="mini" @click="isShowBatchSaveCountCard = false">{{$t('getapi[2054]')}}</el-button>
				<el-button size="mini" type="primary" @click="confirmBatchSaveCountCard">{{$t('getapi[1146]')}}</el-button>
			</span>
        </el-dialog>
    </div>
</template>

<script>
    import Common from '@/components/Common';
    import Array from '@/components/Array';

    export default {
        name: '3_countcard',
        computed: {
            tableOption() {
                return {
                    border: true,
                    height: this.$windowSize.tableHeight3,
                    maxHeight: this.$windowSize.tableHeight3,
                }
            },
            tableHeight(){
                return this.$windowSize.tableHeight3
            }
        },
        data() {
            return {
                tableHeader: [],
                dataSet: [], // 主表数据
                isVisible: false, // 查询列表是否显示
                queryData: [], // 查询数组
                userData: [], // 用户信息
                user: '',
                DbTbNames: '',
                pageIndex: 1, // 当前页
                pageSize: this.$http.getPageSize('3_countcard'), // 当前页数据量
                SelectIndexs: 0, //当前页面
                total: 0, // 数据总量
                loading: false, // 主表加载状态
                dataDetail: {
                    Head: {}
                }, // 编辑页面数据详情
                code: {
                    count_plan_sign: '',
                    count_card_no: ''
                },
                addoredit: 1, //1:新增2：编辑
                isShowChangeCardNo: false, // 修改盘点卡号弹出框
                new_count_card_no: '',
                isShowBatchSaveCountCard: false, // 批量创建无效卡弹出框
                startcardno: '',
                endcardno: '',
                continuousentry: '1', // 是否连续录入
                countmeasureArr:[{
                    label: 'PCS',
                    value: 'PCS'
                },{
                    label: this.$t('getapi[8858]'),//'组',
                    value: '组'
                },{
                    label: this.$t('getapi[8859]'),//'条',
                    value: '条'
                },{
                    label: this.$t('getapi[8860]'),//'只',
                    value: '只'
                },{
                    label: this.$t('getapi[8861]'),//'个',
                    value: '个'
                },{
                    label: 'mm',
                    value: 'mm'
                },{
                    label: this.$t('getapi[8862]'),//'箱',
                    value: '箱'
                },{
                    label: this.$t('getapi[8863]'),//'千克',
                    value: '千克'
                },{
                    label: this.$t('getapi[8864]'),//'支',
                    value: '支'
                },{
                    label: this.$t('getapi[8865]'),//'克',
                    value: '克'
                },{
                    label: this.$t('getapi[8866]'),//'台',
                    value: '台'
                },{
                    label: this.$t('getapi[8867]'),//'张',
                    value: '张'
                },{
                    label: this.$t('getapi[8868]'),//'盎司',
                    value: '盎司'
                },{
                    label: this.$t('getapi[8869]'),//'米',
                    value: '米'
                },{
                    label: this.$t('getapi[8870]'),//'根',
                    value: '根'
                },{
                    label: this.$t('getapi[8871]'),//'盒',
                    value: '盒'
                },{
                    label: this.$t('getapi[8872]'),//'把',
                    value: '把'
                },{
                    label: 'L',
                    value: 'L'
                },{
                    label: this.$t('getapi[8873]'),//'瓶',
                    value: '瓶'
                },
                {
                    label: this.$t('getapi[8874]'),//'包',
                    value: '包'
                },
                {
                    label: this.$t('getapi[8875]'),//'套',
                    value: '套'
                },
                {
                    label: this.$t('getapi[8876]'),//'本',
                    value: '本'
                },{
                    label: 'm²',
                    value: 'm²'
                },{
                    label: this.$t('getapi[8877]'),//'卷',
                    value: '卷'
                },{
                    label: 'ML',
                    value: 'ML'
                },{
                    label: 'M',
                    value: 'M'
                },{
                    label: this.$t('getapi[8878]'),//'桶',
                    value: '桶'
                },{
                    label: this.$t('getapi[8879]'),//'副',
                    value: '副'
                }],
                routingnoArr: [{
                    label: '0',
                    value: '0'
                },{
                    label: '10',
                    value: '10'
                },{
                    label: '20',
                    value: '20'
                },{
                    label: '30',
                    value: '30'
                },{
                    label: '40',
                    value: '40'
                },{
                    label: '50',
                    value: '50'
                },{
                    label: '60',
                    value: '60'
                },{
                    label: '70',
                    value: '70'
                },{
                    label: '80',
                    value: '80'
                },{
                    label: '90',
                    value: '90'
                },{
                    label: '100',
                    value: '100'
                }],
                countareaArr: [],
                oldDataDetail: '',
                timeId: null,
                oldrow: '',
                iscontinuedblclick: true,
                scrollTop:0,
            };
        },
        watch: {
            dataSet: function () {
                let that = this
                that.$nextTick(function () {
                    that.$processdata.initForm(0)
                })
            },
        },
        mounted: function () {
            let that = this;
            that.colsort();
            that.$processdata.pushModelCache('3_countcard', that)
            that.userData = JSON.parse(sessionStorage.getItem('userData'));
            that.user = that.userData.username;
            that.countareaArr = Array.methods.getPropertyPopupList()
            that.$limits.dragControllerDiv();
            that.confirmAdd();
        },
        activated () {
            let that = this
            setTimeout(() => {
                that.$refs.singleTable.$refs.singleTable.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop = res.target.scrollTop
                },false)
            }, 5000);
            // 路由跳转回来滚动到离开时的位置
            this.$nextTick(()=> {
                setTimeout(() => {
                    this.$refs.singleTable.$refs.singleTable.bodyWrapper.scrollTop =this.scrollTop;
                }, 13)
            })
        },
        methods: {
            colsort(){
                let that = this;
                that.$loadviewfields.Fileds('CountCardViewInfo',0,PFileds=>{
                    that.tableHeader=PFileds;
                });
            },
            sortclick(val){
                if(val==1){
                    this.colsort();
                }
            },
            // 修改表格顺序
            opentable(){
                this.$refs.ctab.clearInputs(true);
            },
            help(){
                this.$refs.SetBtn.showHelp(this.$options.name,this.$t("getapi[6689]"),this.$t("getapi[979]"));
            },
            //type 1 一览权限 、2 编辑界面权限
            authority() {
                let that = this;
                if(that.$loadviewfields.isEnableHelp(this.$options.name) == 1){
                    that.$refs.SetBtn.SetOneBtnEnable('help',true);
                }
                that.$refs.SetBtn.SetOneBtnEnable('ctabel', true);
                 //管理界面			 
                if (that.$limits.authority('plv3', 466, 1) == 0) {
                    if(that.total>0){
                        //只读权
                        that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
                    }
                    else{
                        that.$refs.SetBtn.SetButtonEnable('search,refresh');
                    }
                }
                else if (that.$limits.authority('plv3', 466, 1) == 1) {			  
                    //编辑级
                   if(that.total>0){                     
                        that.$refs.SetBtn.SetButtonEnable('create,save,search,refresh,export');
                    } else {
                        that.$refs.SetBtn.SetButtonEnable('create,save,search,refresh');
                    }
                }
                else if (that.$limits.authority('plv3', 466, 1) == 2) {			  
                    //编辑级
                   if(that.total>0){
                       if(that.code.count_plan_sign != ''){
                           that.$refs.SetBtn.SetButtonEnable('create,save,del,search,refresh,export');
                       } else {
                           that.$refs.SetBtn.SetButtonEnable('create,save,search,refresh,export');
                       }
                    } else {
                        that.$refs.SetBtn.SetButtonEnable('create,save,search,refresh');
                    }
                }
                else{
                    that.$refs.SetBtn.SetButtonEnable('search,refresh');
                }
            },
            btnauthority() {
                let that = this;
            },
            openEdit() {
                let that = this
                clearTimeout(that.timeId)
                if(!that.iscontinuedblclick){
                    return
                }
                let left = document.getElementsByClassName('left');
                let mid = document.getElementsByClassName('mid');
                let Box = document.getElementsByClassName('Boxs');
                let bw = Box[0].clientWidth;
                left[0].style.width = '0px';
                mid[0].style.width = '100%';
            },
            colseEdit(){
                let that = this
                let left = document.getElementsByClassName('left');
                let mid = document.getElementsByClassName('mid');
                let Box = document.getElementsByClassName('Boxs');
                let bw = Box[0].clientWidth;
                left[0].style.width = '100%';
                mid[0].style.width = '0px'
            },
            leftt(e) {
                var left = document.getElementsByClassName('left');
                var mid = document.getElementsByClassName('mid');
                var Box = document.getElementsByClassName('Boxs');
                let bw = Box[0].clientWidth;
                if (e == 1) {
                    left[0].style.width = '0px';
                    mid[0].style.width = bw - 13 + 'px';
                } else {
                    left[0].style.width = bw - 50 + 'px';
                    mid[0].style.width = '0px';
                }
            },
            handleSizeChange(val) {
                this.pageSize = val;
                this.$http.savePageSize('3_countcard',val)
                this.getView();
            },
            handleCurrentChange(val) {
                this.pageIndex = val;
                this.getView();
            },
            // 查询
            search() {
                let that = this;
                that.isVisible = true;
                that.$refs.ser.clearInput(that.isVisible, 'CountCardViewInfo');
            },
            //获取查询条件
            serclick(val) {
                this.queryData = val;
                this.confirmGetView();
            },
            // 确认获取数据
            confirmGetView() {
                let that = this;
                that.pageIndex = 1
                that.isVisible = false;
                that.getView();
            },
            // 数据一览
            getView() {
                let that = this;
                that.loading = true;
                let datac = [];
                for (let i = 0; i < that.queryData.length; i++) {
                    datac.push({
                        query_Condition: that.queryData[i].query_Condition,
                        query_field_type: that.queryData[i].Query_Field_Type,
                        query_field_name: that.queryData[i].Query_Field_Name,
                        query_sort: that.queryData[i].query_sort,
                        row_sign: that.queryData[i].row_sign
                    });
                }
                let data = {
                    PageIndex: that.pageIndex,
                    PageSize: that.pageSize,
                    SelectIndex: that.SelectIndexs,
                    Param: datac
                };
                that.$http.urlpost('/Fin/Check/GetCountCardView', data, function (res) {
                    if (res.Success == 1) {
                        that.dataSet = res.DataContent;
                        that.total = res.Totals;
                        that.loading = false;
                        that.DbTbNames = res.DbTbNames;
                        that.authority();
                    }
                });
            },
            // 根据ID获取详情数据
            editInfo(row) {
                let that = this;
                that.timeId = setTimeout(() => {
                    if(that.oldDataDetail != JSON.stringify(that.dataDetail)){
                        that.$confirm(that.$t('getapi[8577]'), that.$t('getapi[194]'), {//'数据已发生变更还未保存，是否切换？'
                            confirmButtonText: that.$t('getapi[2052]'),
                            cancelButtonText: that.$t('getapi[2053]'),
                            closeOnClickModal: false,
                            type: 'warning'
                        })
                            .then(() => {
                                that.iscontinuedblclick = true
                                that.oldrow = row
                                if(that.code.count_plan_sign == row.count_plan_sign && that.code.count_card_no == row.count_card_no)
                                that.addoredit = 2;
                                that.code = {
                                    count_plan_sign: row.count_plan_sign,
                                    count_card_no: row.count_card_no
                                }
                                that.getDetail(that.code);
                            })
                            .catch(() => {
                                that.iscontinuedblclick = false
                                that.$refs.singleTable.$refs.singleTable.setCurrentRow(that.oldrow);
                            });
                    } else {
                        that.iscontinuedblclick = true
                        that.oldrow = row
                        if(that.code.count_plan_sign == row.count_plan_sign && that.code.count_card_no == row.count_card_no)
                        that.addoredit = 2;
                        that.code = {
                            count_plan_sign: row.count_plan_sign,
                            count_card_no: row.count_card_no
                        }
                        that.getDetail(that.code);
                    }

                }, 100);
            },
            // 获取详情数据
            getDetail(parm) {
                let that = this;
                that.addoredit = 2;
                that.$http.urlpost('/Fin/Check/GetCountCardInfo', parm, function (res) {
                    if (res.Success == 1) {
                        that.dataDetail = res.DataContent;
                        that.oldDataDetail = JSON.stringify(that.dataDetail)
                        that.authority();
                    }
                });
            },
            // 新增
            add() {
                let that = this;
                if(that.oldDataDetail != JSON.stringify(that.dataDetail)){
                    that.$confirm(that.$t('getapi[3657]'), that.$t('getapi[194]'), {//'数据已发生变更，是否保存后新建？'
                        confirmButtonText: that.$t('getapi[2052]'),
                        cancelButtonText: that.$t('getapi[2053]'),
                        type: 'warning'
                    })
                        .then(() => {
                            that.save()
                        })
                        .catch(() => {
                            that.openEdit()
                            that.confirmAdd()
                        });
                } else {
                    that.openEdit()
                    that.confirmAdd()
                }
            },
            confirmAdd(){
                let that = this;
                let date = Common.methods.getDate()
                that.addoredit = 1;
                that.code = {
                    count_plan_sign: '',
                    count_card_no: ''
                },
                that.dataDetail = {
                    Head: {
                        count_plan_sign: '',
                        count_card_no: '',
                        dept: '',
                        count_date: date,
                        count_card_flag: 0,
                        count_card_issue_no: '',
                        count_area: '',
                        so_code: '',
                        part_code: '',
                        part_version: '',
                        routing_no: 0,
                        count_qty: '',
                        part_category: '',
                        count_measure: 'PCS',
                        sys_measure: '',
                        remark: '',
                        verify_desc: '',
                        count_person: '',
                        create_person: '',
                        create_time: '',
                        card_flag: 0,
                        item_code: '',
                        isadd: 1
                    },
                };
                that.$http.urlpost('/Fin/Check/GetLatestCountPlanSign', '', function (res) {
                    if (res.Success == 1) {
                        that.dataDetail.Head.count_plan_sign = res.DataContent
                        that.oldDataDetail = JSON.stringify(that.dataDetail)
                    }
                });
                that.oldDataDetail = JSON.stringify(that.dataDetail)
                that.authority();
            },
            // 刷新
            reflash() {
                let that = this;
                if(that.oldDataDetail != JSON.stringify(that.dataDetail)){
                    that.$confirm(that.$t('getapi[3659]'), that.$t('getapi[194]'), {//'数据已发生变更，是否保存后刷新？'
                        confirmButtonText: that.$t('getapi[2052]'),
                        cancelButtonText: that.$t('getapi[2053]'),
                        type: 'warning'
                    })
                        .then(() => {
                            that.save()
                        })
                        .catch(() => {
                            if(that.addoredit == 1){
                                that.getView();
                                that.confirmAdd()
                            } else {
                                that.getView();
                                that.getDetail(that.code)
                            }
                        });
                } else {
                    if(that.addoredit == 1){
                        that.getView();
                        that.confirmAdd()
                    } else {
                        that.getView();
                        that.getDetail(that.code)
                    }
                }
            },
            // 导出
            exps() {
                /*let that = this;
                let datac = [];
                for (let i = 0; i < that.queryData.length; i++) {
                    datac.push({
                        query_Condition: that.queryData[i].query_Condition,
                        query_field_type: that.queryData[i].Query_Field_Type,
                        query_field_name: that.queryData[i].Query_Field_Name,
                        query_sort: that.queryData[i].query_sort,
                        row_sign: that.queryData[i].row_sign
                    });
                }
                let parm = {
                    PageIndex: that.PageIndex,
                    PageSize: that.PageSize,
                    SelectIndex: that.SelectIndex,
                    Ids: '',
                    Param: datac
                };
                that.loading = true
                that.$http.urlpost('/Fin/Check/GetCountCardViewToExecl', parm, function (res) {
                    if (res.Success == 1) {
                        that.loading = false
                        let hrefurl = Common.Url + res.DataContent.URL;
                        window.open(hrefurl);
                    }
                });*/
                let that = this;
                let datac = [];
                for (let i = 0; i < that.queryData.length; i++) {
                    datac.push({
                        query_Condition: that.queryData[i].query_Condition,
                        query_field_type: that.queryData[i].Query_Field_Type,
                        query_field_name: that.queryData[i].Query_Field_Name,
                        query_sort: that.queryData[i].query_sort,
                        row_sign: that.queryData[i].row_sign
                    });
                }
                let parm = {
                    query_sign: "CountCardViewInfo",
                    fromname: that.$t('getapi[6689]'),
                    SelectIndex: 0,
                    MultyVer: that.$processdata.getLanguage(),
                    Param: datac
                };
                that.$processdata.commonExport(parm)
            },
            // 保存
            save() {
                let that = this;
                that.$refs.SetBtn.SetOneBtnEnable('save', false);
                let parm = that.dataDetail.Head;
                parm.LangType = that.$processdata.getLang()
                that.$http.urlpost('/Fin/Check/SavetCountCard', parm, function (res) {
                    if (res.Success == 1) {
                        if(that.continuousentry == '1'){
                            that.confirmAdd()
                        } else {
                            that.code = {
                                count_plan_sign: that.dataDetail.Head.count_plan_sign,
                                count_card_no: that.dataDetail.Head.count_card_no
                            }
                            that.getDetail(that.code)
                        }
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg))
                    } else if(res.Success == 2){
                        if(that.continuousentry == '1'){
                            that.$confirm(that.$t('getapi[8598]'), that.$t('getapi[194]'), {//你录入的卡片信息存在校验错误，是否继续录入？
                                confirmButtonText: that.$t('getapi[1146]'),
                                cancelButtonText: that.$t('getapi[2054]'),
                                type: 'warning'
                            })
                                .then(() => {
                                    that.confirmAdd()
                                })
                                .catch(() => {
                                    this.$message({
                                        type: 'info',
                                        message: that.$t('getapi[6096]')
                                    });
                                });
                        }
                    }
                });
                that.$refs.SetBtn.SetOneBtnEnable('save', true);
            },
            // 删除单据
            del() {
                let that = this;
                this.$confirm(that.$t('getapi[8573]'), that.$t('getapi[194]'), {//'确定删除数据?'
                    confirmButtonText: that.$t('getapi[1146]'),
                    cancelButtonText: that.$t('getapi[2054]'),
                    type: 'warning'
                })
                    .then(() => {
                        let parm = {
                            count_plan_sign: that.dataDetail.Head.count_plan_sign,
                            count_card_no: that.dataDetail.Head.count_card_no
                        }
                        that.$http.urlpost('/Fin/Check/DeltCountCard', parm, function (res) {
                            if (res.Success == 1) {
                                that.$message.success(that.$processdata.explainCallbackMsg(res.Msg))
                                that.getView()
                                that.confirmAdd()
                            }
                        });
                    })
                    .catch(() => {
                        this.$message({
                            type: 'info',
                            message: that.$t('getapi[8574]')
                        });
                    });
            },
            changeCardNo(){
                let that = this
                that.isShowChangeCardNo = true
            },
            confirmChangeCardNo(){
                let that = this
                let parm = {
                    count_plan_sign: that.dataDetail.Head.count_plan_sign,
                    count_card_no: that.dataDetail.Head.count_card_no,
                    new_count_card_no: that.new_count_card_no
                }
                that.$http.urlpost('/Fin/Check/ChangeCardNo', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg))
                        that.isShowChangeCardNo = false
                        that.getDetail(that.code)
                        that.getView()
                    }
                });
            },
            batchSaveCountCard(){
                let that = this
                that.isShowBatchSaveCountCard = true
            },
            confirmBatchSaveCountCard(){
                let that = this
                let parm = {
                    startcardno: that.startcardno,
                    endcardno: that.endcardno,
                    Head: that.dataDetail.Head,
                    LangType:that.$processdata.getLang(),
                }
                that.$http.urlpost('/Fin/Check/BatchSavetCountCard', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg))
                        that.isShowBatchSaveCountCard = false
                        that.getView()
                    }
                });
            },
            verify(){
                let that = this
                let parm = that.dataDetail.Head
                that.$http.urlpost('/Fin/Check/CountCardVerify', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg))
                    }
                });
            },
            // 根据输入的So号码获取相关信息
            getPartInfo(){
                let that = this
                let parm = {
                    Code: that.dataDetail.Head.so_code
                }
                that.$http.urlpost('/Fin/Check/GetPartInfoSOCode', parm, function (res) {
                    if (res.Success == 1) {
                        if(res.DataContent){
                            let data = res.DataContent.Head
                            that.dataDetail.Head.part_code = data.part_code
                            that.dataDetail.Head.part_version = data.part_version
                            that.dataDetail.Head.part_category = data.part_category
                            that.dataDetail.Head.sys_measure = data.sys_measure
                            that.dataDetail.Head.item_code = data.item_code
                        } else {
                            that.dataDetail.Head.part_code = ''
                            that.dataDetail.Head.part_version = ''
                            that.dataDetail.Head.part_category = ''
                            that.dataDetail.Head.sys_measure = ''
                            that.dataDetail.Head.item_code = ''
                        }
                    }
                });
            },
            checkDataChange(){
                let that = this
                //如果无保存权限，直接关闭
                if(that.$limits.authority('plv3', 466,1) < 1){
                    return false
                }
                let flag =  that.oldDataDetail != JSON.stringify(that.dataDetail)
                return flag
            }
        }
    };
</script>

<style scoped lang="less">
    table {
        border-collapse: separate;
        border-spacing: 0px 5px;
        td {
            padding-left: 3px;
            white-space: pre;
        }
    }

    /deep/ .gray {
        background: #cac6c6;
    }
</style>
